import {
  Action,
  OperationType,
  Position,
  WarningType
} from '../../../../dispatcher/Types';

/**
 * Requests filter based on saved filter props
 */
export const ApplyFilter: Action = [{
  name: 'LoadFilter',
  type: OperationType.action
}, {
  args: ['filterName', 'filterColor', 'filterParams'],
  moduleName: 'FilterDialog',
  name: 'loadSavedFilterAndSearch'
}];

/**
 * Loads saved filter props into filters form
 */
export const LoadFilter: Action = [{
  args: ['filterName', 'filterColor', 'filterParams'],
  moduleName: 'FilterDialog',
  name: 'loadSavedFilter'
}];

/**
 * Clones currently selected saved filter
 */
export const CloneFilter: Action = [{
  args: ['filterName'],
  moduleName: 'FilterDialog',
  name: 'getCloneFilterName',
  mappingName: 'filterName',
  type: OperationType.addOperationData
}, {
  args: ['filterName', 'filterColor', 'filterParams'],
  moduleName: 'FilterDialog',
  name: 'loadSavedFilterAndSaveNewOne'
}];

export const DeleteFilterFlow: Action = [{
  items: [{
    btnName: 'deleteFilterFlow.no',
    btnConfig: {
      pos: Position.end
    }
  }, {
    btnName: 'deleteFilterFlow.yes',
    btnConfig: {
      pos: Position.end
    },
    operations: [{
      name: 'DeleteFilter',
      type: OperationType.action
    }, {
      persistent: ['filterName', 'url', 'name'],
      type: OperationType.removePersistentData
    }]
  }],
  placeholders: {
    template: {
      bind: {
        filterName: '{filterName}',
        name: '{name}'
      }
    }
  },
  text: 'deleteFilterFlow.text',
  title: 'deleteFilterFlow.title',
  type: OperationType.warning,
  warningType: WarningType.warning
}];

/**
 * Deletes saved filter
 */
export const DeleteFilter: Action = [{
  moduleName: 'SearchBar',
  name: 'getDashboard',
  mappingName: 'dashboard',
  type: OperationType.addOperationData
}, {
  data: {
    filterUrlParamsName: 'urlParams'
  },
  name: 'getEndPoint',
  args: ['filterUrlParamsName'],
  moduleName: 'SearchBar',
  mappingName: 'filterUrlParams',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        rememberUrl: '{url}'
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    template: {
      method: 'delete',
      bind: {
        url: '{url}',
        urlParams: '{filterUrlParams}'
      },
      params: {
        bind: {
          name: '{filterName}',
          dashboard: '{dashboard}'
        },
        userName: '{filterUrlParams}.usernameFilters'
      }
    }
  },
  // mappingName: 'savedFilters',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        url: '{rememberUrl}',
        urlParams: '{filterUrlParams}'
      }
    }
  },
  name: 'GetSavedFilters',
  type: OperationType.action
}, {
  args: ['savedFilters'],
  name: 'updateSavedFilters',
  moduleName: 'FilterDialog'
}];
